@if (!hidden()) {
  <mp-multi-selection-group
    filterName="Adresstyp"
    icon="filter_alt"
    [options]="options"
    [showSelectionInfo]="true"
    (selectedValuesChange)="filterChange.emit($event)"
  />
}
